<template>
    <div class="tab-pane fade show active position-relative" id="activity">
        <transition name="vue-table-loader">
            <div class="vue-details-loader alt" v-if="loading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <transition name="vue-table-loader">
            <div class="vue-details-loader transparent" v-if="transparentLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
	    </transition>
        <div class="product-form-tab">
            <div class="form-element-container">
                <div class="row p-0 mb-5">
                    <div class="col-md-12 clearfix d-flex flex-column">
                        <div class="d-flex flex-column">
                            <h3>Channels</h3>
                            <p class="text-muted text-xs max-w-para">
                                This view contains a listing of all the channels in the PIM. Depending on a user's permissions they
                                may be able to enable/disable channels or edit certain channel parameters.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="dataTables_wrapper container-fluid dt-bootstrap4">
                    <vuetable ref="vuetable"
                        :api-url="grid"
                        :fields="fields"
                        :css="css.table"
                        :per-page="perPage"
                        :append-params="moreParams"
                        noDataTemplate="No Channels Found"
                        pagination-path=""
                        @vuetable:loaded="onLoaded"
                        @vuetable:load-success="onLoadSuccess"
                        @vuetable:load-error="onLoadError"
                    >
                        <template slot="logo" slot-scope="props">
                            <div class="channel-logo-container">
                                <img v-if="!props.rowData.logo"  class="channel-logo" :src="baseUrl + '/images/channels/logo-'+props.rowData.type[Object.keys(props.rowData.type)]+'.png'" alt="">
                                <img v-else  class="channel-logo" :src="props.rowData.logo" alt="">
                                <div class="globally-disabled-channel" v-if="!props.rowData.sync">Disabled</div>
                            </div>
                        </template>
                        <template slot="namewebid" slot-scope="props">
                            <div>{{props.rowData.channel_name}}</div>
                            <div v-if="props.rowData.web_id" class=""><small>Web ID: {{(props.rowData.web_id) ? props.rowData.web_id : 'N/A'}}</small></div>
                            <div v-if="props.rowData.sku_web_id" class=""><small>SKU Web ID: {{(props.rowData.sku_web_id) ? props.rowData.sku_web_id : 'N/A'}}</small></div>
                            <div v-if="props.rowData.last_sync_datetime"><small>Last sync at: {{props.rowData.last_sync_datetime}}</small></div>
                            <div v-if="props.rowData.last_sync_result"><small>Last sync result: {{props.rowData.last_sync_result}}<span v-if="props.rowData.last_sync_message" class="text-underline cursor-pointer" v-on:click="displayModal(props.rowData.last_sync_message, 'Message')">, more</span></small></div>
                            <div v-if="props.rowData.id"><small>Request Payload: <span class="text-underline cursor-pointer" v-on:click="displayPayloadModal(props.rowData.id, 'Message')">OPEN <i class="fa fa-search" aria-hidden="true"></i></span></small></div>
                            <div v-if="!props.rowData.sync" class="color-danger">This channel will need to be enabled in the <a target="_blank" :href="baseUrl + '/channels/'+props.rowData.id+'/edit'">channels configuration</a> before it can sync.</div>
                        </template>
                        <template slot="status" slot-scope="props">
                            <div v-if="props.rowData.product_workflow_enabled && isWorkflowFeatureEnabled" class="badge badge-success">
                                <span>Workflow</span>
                                <span class="d-block mt-2">({{props.rowData.product_workflow_readiness}}% ready)</span>
                            </div>
                            <div v-else-if="props.rowData.enabled" class="badge badge-success">
                                Enabled
                            </div>
                            <div v-else class="badge badge-warning">
                                Disabled
                            </div>
                        </template>
                        <template slot="actions" slot-scope="props" v-if="$parent.permissionAllowed('manage_products') && $parent.permissionAllowed('manage_channels')">
                            <div class="channel-action-container">
                                <div class="channel-action-row">
                                    <div class="dropdown channel-tool-menu ml-1">
                                        <button type="button" :ref="'channelDropdownBtns-'+props.rowData.id"  class="btn btn-outline-primary " data-toggle="dropdown">
                                            <i class="fa fa-cog" aria-hidden="true"></i>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right" id="batch_operation">
                                            <div class="dropdown-item d-flex flex-column" v-if="props.rowData.show_schedule_release">
                                                <label for="" class="mb-2">Schedule Release</label>
                                                <div class="input-group">
                                                    <input v-if="props.rowData.release_at" type="datetime-local" class="html5_datetimepicker form-control form-control-sm mb-2" :id="'datetime_' + props.rowData.id" :value="props.rowData.release_at" @change="formatMinutes(props.rowData.id)">
                                                    <input v-else type="datetime-local" class="html5_datetimepicker form-control form-control-sm mb-2" :id="'datetime_' + props.rowData.id" value="" @change="formatMinutes(props.rowData.id)">
                                                </div>
                                                <div class="input-group-append channel-action-row schedule-buttons">
                                                    <button class="btn btn-primary btn-sm" @click="releaseDateProductChannel(props.rowData.id, 'post')"><i class="fas fa-check"></i></button>
                                                    <button class="btn btn-danger btn-sm" @click="releaseDateProductChannel(props.rowData.id)"><i class="fa fa-trash"></i></button>
                                                </div>
                                            </div>
                                            <div class="dropdown-divider" v-if="props.rowData.sync"></div>
                                            <div class="dropdown-item" v-if="props.rowData.sync">
                                                <div class="d-flex flex-column">
                                                    <label for="" class="mb-2">Toggle Status</label>
                                                    <select @click.stop class="form-control form-control-sm" name="toggle-status" @change="updateChannel(props.rowData.id, $event)">
                                                        <option value="enabled" :selected="props.rowData.enabled && ((isWorkflowFeatureEnabled && !props.rowData.product_workflow_enabled) || !isWorkflowFeatureEnabled)">
                                                            Enabled
                                                        </option>
                                                        <option value="disabled" :selected="!props.rowData.enabled && ((isWorkflowFeatureEnabled && !props.rowData.product_workflow_enabled) || !isWorkflowFeatureEnabled)">
                                                            Disabled
                                                        </option>
                                                        <option v-if="isWorkflowFeatureEnabled && props.rowData.workflow_id" value="workflow" :selected="isWorkflowFeatureEnabled && props.rowData.product_workflow_enabled">
                                                            Workflow ({{props.rowData.product_workflow_readiness}}% ready)
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="dropdown-divider" v-if="props.rowData.has_variants || props.rowData.web_id || props.rowData.external_admin_url || props.rowData.external_product_url"></div>
                                            <a :href="baseUrl + '/channels/'+props.rowData.id+'/edit'" class="dropdown-item">
                                                <span>Edit Channel</span>
                                            </a>
                                            <div class="dropdown-item" v-if="props.rowData.sync && props.rowData.has_variants">
                                                <div class="d-flex flex-column">
                                                    <label for="" class="mb-2">Toggle All Variants Status</label>
                                                    <select @click.stop class="form-control form-control-sm" name="toggle-status" @change="updateVariantsChannel(props.rowData.id, $event)">
                                                        <option value="">
                                                            Choose an option
                                                        </option>
                                                        <option value="enabled">
                                                            Enabled
                                                        </option>
                                                        <option value="disabled">
                                                            Disabled
                                                        </option>
                                                        <option v-if="isWorkflowFeatureEnabled && props.rowData.workflow_id" value="workflow">
                                                            Workflow
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <button v-if="props.rowData.web_id && props.rowData.supports_delete" v-on:click="deleteProductOnChannel(props.rowData.id)" class="dropdown-item">
                                                <span>Delete Product From Channel</span>
                                            </button>
                                            <button v-if="props.rowData.web_id" v-on:click="detachProductFromChannel(props.rowData.id)" class="dropdown-item">
                                                <span>Clear External ID</span>
                                            </button>
                                            <button v-if="props.rowData.external_product_url" :href="props.rowData.external_product_url" class="dropdown-item">
                                                <span>View External Product</span>
                                            </button>
                                            <button v-if="props.rowData.external_admin_url" :href="props.rowData.external_admin_url" class="dropdown-item">
                                                <span>View External Admin</span>
                                            </button>
                                            <button v-if="props.rowData.sync && props.rowData.enabled" v-on:click="syncProductChannelNow(props.rowData.id, 'full')" class="dropdown-item">
                                                <span>Full Sync</span>
                                            </button>
                                            <button v-if="props.rowData.web_id && props.rowData.sync && props.rowData.enabled" v-on:click="syncProductChannelNow(props.rowData.id, 'full_no_assets')" class="dropdown-item">
                                                <span>Full Sync Except Assets</span>
                                            </button>
                                            <button v-if="props.rowData.web_id && props.rowData.sync && props.rowData.enabled" v-on:click="syncProductChannelNow(props.rowData.id, 'details')" class="dropdown-item">
                                                <span>Sync Details</span>
                                            </button>
                                            <button v-if="props.rowData.web_id && props.rowData.sync && props.rowData.enabled" v-on:click="syncProductChannelNow(props.rowData.id, 'price')" class="dropdown-item">
                                                <span>Sync Price</span>
                                            </button>
                                            <button v-if="props.rowData.web_id && props.rowData.sync && props.rowData.enabled" v-on:click="syncProductChannelNow(props.rowData.id, 'assets')" class="dropdown-item">
                                                <span>Sync Assets</span>
                                            </button>
                                            <button v-if="props.rowData.web_id && props.rowData.sync && props.rowData.enabled" v-on:click="syncProductChannelNow(props.rowData.id, 'inventory')" class="dropdown-item">
                                                <span>Sync Inventory</span>
                                            </button>
                                            <button v-if="props.rowData.web_id && props.rowData.sync && props.rowData.enabled" v-on:click="syncProductChannelNow(props.rowData.id, 'details_with_attributes')" class="dropdown-item">
                                                <span>Sync Attributes</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </vuetable>
                </div>
                <transition name="vue-table-loader">
                    <div class="messaging" v-if="message">{{message}}</div>
                </transition>
            </div>
        </div>

        <div class="modal fade" id="modalLogMessage">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{ modalTitle }}</h4>
                    </div>
                    <div class="modal-body">
                        <pre>
                        <strong style="display: block;">{{ modalMessage }}</strong>
                        </pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var base_url = window.location.protocol + "//" + window.location.host;
import axios from "axios";
import BasePagination from "../tables/base-pagination.vue";
import BasePaginationInfo from "../tables/base-pagination-info.vue";
import moment from "moment";

export default {
    name: "product-channels",
    components: {
        "base-pagination": BasePagination,
        "base-pagination-info": BasePaginationInfo
    },
    data() {
        return {
            perPage: 10,
            loading: true,
            transparentLoading: false,
            moreParams: {},
            confirmationMessage: "",
            product: this.productDetails,
            productActivity: [],
            activeError: null,
            initialTableLoad: false,
            fields: [
                {
                    name: "__slot:logo",
                    title: "Type",
                    titleClass: "channel-logo-col"
                },
                {
                    name: "__slot:namewebid",
                    title: "Name"
                },
                {
                    name: "msrp",
                    title: "MSRP",
                    sortField: "msrp",
                    titleClass: "actions-single-column"
                },
                {
                    name: "map",
                    title: "MAP",
                    sortField: "map",
                    titleClass: "actions-single-column"
                },
                {
                    name: "cost",
                    title: "Cost",
                    sortField: "cost",
                    titleClass: "actions-single-column"
                },
                {
                    name: "sell_price",
                    title: "Sell",
                    sortField: "sell_price",
                    titleClass: "actions-single-column"
                },
                ,
                {
                    name: "__slot:status",
                    title: "Status",
                    titleClass: "actions-single-column"
                },
                {
                    name: "__slot:actions",
                    title: "Actions",
                    titleClass: "channel-actions-column text-right"
                }
            ],
            baseUrl: base_url,
            grid:
                base_url +
                "/pimapi/products/" +
                this.$parent.product.info.id +
                "/channels",
            css: {
                table: {
                    tableClass: "table table-middle table-minimal",
                    ascendingIcon: "sort-icon-asc",
                    descendingIcon: "sort-icon-desc",
                    infoClass: ""
                }
            },
            modalTitle: "",
            modalMessage: "",
            releaseDate: [],
            message:""
        };
    },
    methods: {
        displayLogo(value) {
            if (value[0] == null) {
                return '<div class="productthumbnail_disabled text-center"><i class="fa fa-picture-o" aria-hidden="true"></i></div>';
            }
            return (
                '<div class="text-center "><img  style="max-height: 30px;" src="' +
                value +
                '" ></div>'
            );
        },
        formatDate(value) {
            if (value === null) {
                return "Never";
            }
            return moment(value).format("MMM Do YYYY h:mm a");
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoaded: function() {
            this.loading = false;
            this.initialTableLoad = true;
        },
        onLoadSuccess: function() {
            if (this.initialTableLoad) {
                this.transparentLoading = false;
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = this.confirmationMessage;

                setTimeout(function() {
                    this.confirmationMessage = "";
                    this.$parent.alert.status = "";
                    this.$parent.alert.message = "";
                }, this.$parent.alert.timeOut);
            }
        },
        onLoadError: function() {
            if (this.initialTableLoad) {
                this.transparentLoading = false;
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = this.activeError.response.data.message;

                setTimeout(function() {
                    this.activeError = null;
                    this.$parent.alert.status = "";
                    this.$parent.alert.message = "";
                }, this.$parent.alert.timeOut);
            }
        },
        updateChannel: function(channelId, event) {
            this.$refs['channelDropdownBtns-'+channelId].click();
            this.transparentLoading = true;
            axios
                .post(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.product.info.id +
                        "/channels/" +
                        channelId,
                    {
                        status: event.target.value
                    }
                )
                .then(
                    function(response) {
                        this.confirmationMessage = "Channel has been updated";
                        this.$refs.vuetable.reload();
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.activeError = error;
                        this.$refs.vuetable.reload();
                    }.bind(this)
                );
        },
        updateVariantsChannel: function(channelId, event) {
            let status = event.target.value;

            if(status)
            {
                this.transparentLoading = true;
                axios
                    .post(`${base_url}/pimapi/products/${this.$parent.product.info.id}/channels/${channelId}/change-variants-status`,
                        {
                            status: event.target.value
                        }
                    )
                    .then(
                        function(response) {
                            this.confirmationMessage = "Variants channel configuration updated.";
                            this.$refs.vuetable.reload();
                        }.bind(this)
                    )
                    .catch(
                        function(error) {
                            this.activeError = error;
                            this.$refs.vuetable.reload();
                        }.bind(this)
                    );

                this.$refs['channelDropdownBtns-'+channelId].click();
            }
        },
        deleteProductOnChannel: function(channelId) {
            this.transparentLoading = true;
            axios
                .delete(
                    `${base_url}/pimapi/products/${
                        this.$parent.product.info.id
                    }/channels/${channelId}`
                )
                .then(
                    function(response) {
                        this.confirmationMessage = "Removal was queued.";
                        this.$refs.vuetable.reload();
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.activeError = error;
                        this.$refs.vuetable.reload();
                    }.bind(this)
                );
        },
        detachProductFromChannel: function(channelId) {
            this.transparentLoading = true;
            axios
                .get(
                    `${base_url}/pimapi/products/${
                        this.$parent.product.info.id
                    }/channels/${channelId}/detach`
                )
                .then(
                    function(response) {
                        this.confirmationMessage = "Detach Completed.";
                        this.$refs.vuetable.reload();
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.activeError = error;
                        this.$refs.vuetable.reload();
                    }.bind(this)
                );
        },
        formatMinutes: function(channelId) {
            let datetimepicker = document.getElementById(
                "datetime_" + channelId
            );

            let datetime = Date.parse(datetimepicker.value);
            let year = new Date(datetime).getFullYear();
            let month = new Date(datetime).getMonth() + 1;
            let day = new Date(datetime).getDate();
            let minutes = new Date(datetime).getMinutes();
            let hours = new Date(datetime).getHours();

            if (day < 10) {
                day = "0" + day;
            }
            if (month < 10) {
                month = "0" + month;
            }
            if (minutes > 30) {
                ++hours % 24;
            }
            minutes = "00";

            let newValue =
                year + "-" + month + "-" + day + "T" + hours + ":" + minutes;

            datetimepicker.value = newValue;
        },
        releaseDateProductChannel: function(channelId, action = "clear") {
            this.transparentLoading = true;
            let message = "Schedule release saved";
            let dateControl = document.getElementById("datetime_" + channelId);

            if (action == "clear") {
                message = "Schedule release cleared";
                dateControl.value = "";
            }

            axios
                .post(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.product.info.id +
                        "/channels/" +
                        channelId +
                        "/release-date",
                    {
                        release_date: dateControl.value
                    }
                )
                .then(
                    function(response) {
                        this.confirmationMessage = message;
                        this.$refs.vuetable.reload();
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.activeError = error;
                        this.$refs.vuetable.reload();
                    }.bind(this)
                );
        },
        syncProductChannelNow: function(channelId, type) {
            this.loading = true;
            axios
                .post(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.product.info.id +
                        "/channels/" +
                        channelId +
                        "/sync-now",
                    {
                        type: type
                    }
                )
                .then(
                    function(response) {
                        this.confirmationMessage =
                            "The sync has been initialized";
                        this.$refs.vuetable.reload();
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.activeError = error;
                        this.$refs.vuetable.reload();
                    }.bind(this)
                )
                .finally(
                    function() {
                        this.loading = false;
                    }.bind(this)
                );
        },
        displayModal: function(message, title = "Message") {
            this.modalTitle = title;
            this.modalMessage = message;
            $("#modalLogMessage").modal("show");
        },
        displayPayloadModal: function(channelId, title = "Message") {
            this.modalMessage = '';
            axios
                .get(
                    `${base_url}/pimapi/products/${
                        this.$parent.product.info.id
                    }/channels/${channelId}/product/json`
                )
                .then(
                    function(response) {
                        this.modalTitle = title;
                        this.modalMessage = response.data;
                        $("#modalLogMessage").modal("show");
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.activeError = error;
                        this.$refs.vuetable.reload();
                    }.bind(this)
                );
        }
    },
    computed: {
        features() {
            return this.$parent.$parent.enabledFeatures ? this.$parent.$parent.enabledFeatures : [];
        },
        isWorkflowFeatureEnabled(){
            return this.features.includes('channel_workflow');
        }
    }
};
</script>
<style lang="scss" scoped>
.channel-actions-column {
    width: 6rem;
}

.channel-tool-menu {
    display: inline;
    .btn {
        margin-top: -1px;
        width: 26px;
        height: 26px;
        padding: 0 0;
        border-color: #adadad;
        color: #686868;
    }
}
.table-minimal {
    margin-bottom: 0px !important;
}
.product-tool-menu {
    display: inline;
}
.channel-action-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.channel-action-row {
    display: flex;
    align-items: center;
}

.activities-table {
    min-height: 680px;
}
.channel-logo {
    width: 35px;
}
.badge-checkbox {
    text-transform: capitalize;
    border-color: #adadad;
    background-color: #fff;
    color: #686868;
    margin-top: 5px;
    width: 73px;
    .checkmark {
        border-color: #adadad;
        &:after {
            color: #3cab9f;
        }
    }
    &.badge-checkbox-checked {
        color: white;
        background-color: #3cab9f;
        border-color: #3cab9f;
        .checkmark {
            border-color: white;
        }
    }
}
.messaging {
    color: #566670;
    position: absolute;
    bottom: 2px;
    right: 5px;
    font-size: 9px;
}
.globally-disabled-channel {
    border-color: #ab5755 !important;
    background-color: #ab5755 !important;
    color: #ffffff;
    padding: 1px 3px 1px 3px;
    border-radius: 3px;
    font-size: 10px;
    position: absolute;
    left: 0px;
    right: 0px;
    bottom: -2px;
}
.channel-logo-container {
    position: relative;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    border: 1px solid #dee0e1;
    text-align: center;
    img {
        max-height: 65%;
        max-width: 65%;
        width: auto;
        height: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
}
.color-danger {
    color: #ab5755 !important;
    font-size: 11px;
    font-weight: 400;
    a {
        color: #ab5755 !important;
        text-decoration: underline;
    }
}
.html5_datetimepicker {
    width: auto;
}

.schedule-buttons {
    .btn {
        width: 50% !important;
        color: #fff;
    }
}

.schedule-checkbox {
    border: none;
    color: #000;
    background: transparent;
}
</style>
